import { render } from "./RiTutorial04.vue?vue&type=template&id=ceefff22"
import script from "./RiTutorial04.vue?vue&type=script&lang=js"
export * from "./RiTutorial04.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiTutorial04.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ceefff22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ceefff22', __exports__)) {
    api.reload('ceefff22', __exports__)
  }
  
  module.hot.accept("./RiTutorial04.vue?vue&type=template&id=ceefff22", () => {
    api.rerender('ceefff22', render)
  })

}


export default __exports__